import KeenSlider from 'keen-slider';
import { $$, $1, on } from './utils';
$$('.slider-container').forEach(function (elem) {
    var _a, _b;
    var slider = new KeenSlider(elem.querySelector('.keen-slider'), {
        loop: true,
    });
    (_a = elem.querySelector('.slide-left')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () { return slider.prev(); });
    (_b = elem.querySelector('.slide-right')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () { return slider.next(); });
});
on('click', '[data-hover-replace]', function (ev) {
    var img = ev.currentTarget;
    var target = $1(img.dataset.hoverReplace);
    target.src = img.dataset.src;
    target.srcset = img.dataset.srcset;
    target.sizes = img.dataset.sizes;
});
